// extracted by mini-css-extract-plugin
export default {"artwork":"artwork_artwork__YQVLV","artwork-wrapper":"artwork_artwork-wrapper__6a53l","artworkWrapper":"artwork_artwork-wrapper__6a53l","gradient":"artwork_gradient__TUQmv"};